<template>
  <div class="life-page deduction-page">
    <section class="life-panel deduction-nav">
      <div class="life-panel__head">
        <h2 class="life-panel__title">抵扣金运营</h2>
        <el-tag size="small" effect="plain">{{ isPlatform ? '平台运营' : '物业月结' }}</el-tag>
      </div>
      <el-tabs v-model="activeTab" @tab-click="changeTab">
        <el-tab-pane v-if="isPlatform" label="账户" name="accounts" />
        <el-tab-pane v-if="isPlatform" label="收益" name="earnings" />
        <el-tab-pane v-if="isPlatform" label="到账批次" name="creditLots" />
        <el-tab-pane v-if="isPlatform" label="账户流水" name="transactions" />
        <el-tab-pane v-if="isPlatform" label="支付异常" name="exceptions" />
        <el-tab-pane v-if="isPlatform" label="待追偿" name="recoverables" />
        <el-tab-pane label="物业月结" name="settlement" />
      </el-tabs>
    </section>

    <section class="life-panel">
      <div v-if="activeTab === 'accounts' || activeTab === 'recoverables'" class="life-filter">
        <el-input v-model.trim="filters.userId" placeholder="用户 ID" clearable style="width: 220px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div v-else-if="activeTab === 'earnings'" class="life-filter">
        <el-input v-model.trim="filters.userId" placeholder="用户 ID" clearable style="width: 210px" />
        <el-select v-model="filters.platformCode" placeholder="来源平台" clearable style="width: 140px">
          <el-option label="京东" value="JD" />
          <el-option label="美团" value="MEITUAN" />
        </el-select>
        <el-select v-model="filters.earningStatus" placeholder="收益状态" clearable style="width: 150px">
          <el-option v-for="item in earningStatuses" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div v-else-if="activeTab === 'creditLots'" class="life-filter">
        <el-input v-model.trim="filters.userId" placeholder="用户 ID" clearable style="width: 210px" />
        <el-select v-model="filters.platformCode" placeholder="来源平台" clearable style="width: 140px">
          <el-option label="京东" value="JD" />
          <el-option label="美团" value="MEITUAN" />
          <el-option label="历史迁移" value="MIGRATION" />
        </el-select>
        <el-select v-model="filters.lotStatus" placeholder="批次状态" clearable style="width: 150px">
          <el-option v-for="item in creditLotStatuses" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div v-else-if="activeTab === 'transactions'" class="life-filter">
        <el-input v-model.trim="filters.userId" placeholder="用户 ID" clearable style="width: 220px" @keyup.enter.native="search" />
        <el-select v-model="filters.txnType" placeholder="流水类型" clearable filterable style="width: 210px">
          <el-option v-for="item in transactionTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div v-else-if="activeTab === 'exceptions'" class="life-filter">
        <el-select v-model="filters.status" placeholder="处理状态" clearable style="width: 140px">
          <el-option label="待处理" value="OPEN" />
          <el-option label="已解决" value="RESOLVED" />
        </el-select>
        <el-input v-model.trim="filters.exceptionType" placeholder="异常类型" clearable style="width: 220px" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div v-else class="life-filter deduction-settlement-filter">
        <el-radio-group v-model="settlementView" size="small" @change="search">
          <el-radio-button label="batches">月结批次</el-radio-button>
          <el-radio-button label="payables">应付明细</el-radio-button>
        </el-radio-group>
        <el-input v-if="isPlatform" v-model.trim="filters.propertyCompanyId" placeholder="物业公司 ID" clearable style="width: 210px" />
        <el-date-picker v-model="filters.settlementMonth" type="month" value-format="yyyy-MM" placeholder="月份" style="width: 150px" />
        <el-select v-model="filters.state" placeholder="状态" clearable style="width: 140px">
          <el-option v-for="item in settlementStateOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button v-if="isPlatform && settlementView === 'batches'" type="primary" plain icon="el-icon-plus" @click="openGenerate">生成批次</el-button>
      </div>
    </section>

    <section class="life-panel">
      <el-table v-if="activeTab === 'accounts' || activeTab === 'recoverables'" v-loading="loading" :data="rows" border>
        <el-table-column prop="accountId" label="账户 ID" min-width="190" class-name="life-id" />
        <el-table-column prop="userId" label="用户 ID" min-width="180" class-name="life-id" />
        <el-table-column label="待结算" width="120" align="right"><template slot-scope="scope"><span class="life-money">¥{{ money(scope.row.pendingAmount) }}</span></template></el-table-column>
        <el-table-column label="可用" width="120" align="right"><template slot-scope="scope"><span class="life-money is-positive">¥{{ money(scope.row.availableAmount) }}</span></template></el-table-column>
        <el-table-column label="冻结" width="120" align="right"><template slot-scope="scope"><span class="life-money">¥{{ money(scope.row.frozenAmount) }}</span></template></el-table-column>
        <el-table-column label="待追偿" width="120" align="right"><template slot-scope="scope"><span :class="['life-money', Number(scope.row.recoverableAmount || 0) > 0 ? 'is-danger' : '']">¥{{ money(scope.row.recoverableAmount) }}</span></template></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="170" />
        <el-table-column v-if="activeTab === 'accounts'" label="操作" width="150" fixed="right"><template slot-scope="scope">
          <el-button type="text" icon="el-icon-tickets" @click="openUserDetails(scope.row, 'creditLots')">批次</el-button>
          <el-button type="text" icon="el-icon-document" @click="openUserDetails(scope.row, 'transactions')">流水</el-button>
        </template></el-table-column>
      </el-table>

      <el-table v-else-if="activeTab === 'earnings'" v-loading="loading" :data="rows" border>
        <el-table-column prop="earningId" label="收益 ID" min-width="190" class-name="life-id" />
        <el-table-column prop="userId" label="用户 ID" min-width="160" class-name="life-id" />
        <el-table-column prop="platformCode" label="平台" width="95" align="center" />
        <el-table-column prop="affiliateOrderId" label="导购订单" min-width="180" class-name="life-id" />
        <el-table-column label="状态" width="125"><template slot-scope="scope"><el-tag :type="earningStatusType(scope.row.earningStatus)" size="small">{{ earningStatusName(scope.row.earningStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="结算金额" width="120" align="right"><template slot-scope="scope"><span class="life-money">¥{{ money(scope.row.settledAmount) }}</span></template></el-table-column>
        <el-table-column label="可用剩余" width="120" align="right"><template slot-scope="scope"><span class="life-money">¥{{ money(scope.row.availableRemaining) }}</span></template></el-table-column>
        <el-table-column label="已消费" width="110" align="right"><template slot-scope="scope">¥{{ money(scope.row.consumedAmount) }}</template></el-table-column>
        <el-table-column label="已冲正" width="110" align="right"><template slot-scope="scope">¥{{ money(scope.row.reversedAmount) }}</template></el-table-column>
        <el-table-column label="已过期" width="110" align="right"><template slot-scope="scope"><span :class="Number(scope.row.expiredAmount || 0) > 0 ? 'is-danger' : ''">¥{{ money(scope.row.expiredAmount) }}</span></template></el-table-column>
        <el-table-column prop="settledAt" label="结算时间" width="170" />
      </el-table>

      <el-table v-else-if="activeTab === 'creditLots'" v-loading="loading" :data="rows" border>
        <el-table-column prop="creditLotId" label="到账批次 ID" min-width="190" class-name="life-id" />
        <el-table-column prop="userId" label="用户 ID" min-width="160" class-name="life-id" />
        <el-table-column prop="platformCode" label="平台" width="95" align="center" />
        <el-table-column prop="affiliateOrderId" label="来源订单" min-width="180" class-name="life-id" />
        <el-table-column label="状态" width="105"><template slot-scope="scope"><el-tag :type="creditLotStatusType(scope.row.lotStatus)" size="small">{{ creditLotStatusName(scope.row.lotStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="到账金额" width="115" align="right"><template slot-scope="scope">¥{{ money(scope.row.originalAmount) }}</template></el-table-column>
        <el-table-column label="可用" width="105" align="right"><template slot-scope="scope"><span class="is-positive">¥{{ money(scope.row.availableAmount) }}</span></template></el-table-column>
        <el-table-column label="冻结" width="105" align="right"><template slot-scope="scope">¥{{ money(scope.row.frozenAmount) }}</template></el-table-column>
        <el-table-column label="已消费" width="105" align="right"><template slot-scope="scope">¥{{ money(scope.row.consumedAmount) }}</template></el-table-column>
        <el-table-column label="已冲正" width="105" align="right"><template slot-scope="scope">¥{{ money(scope.row.reversedAmount) }}</template></el-table-column>
        <el-table-column label="已过期" width="105" align="right"><template slot-scope="scope"><span :class="Number(scope.row.expiredAmount || 0) > 0 ? 'is-danger' : ''">¥{{ money(scope.row.expiredAmount) }}</span></template></el-table-column>
        <el-table-column prop="settledAt" label="到账时间" width="170" />
        <el-table-column prop="expiresAt" label="到期时间" width="170" />
      </el-table>

      <el-table v-else-if="activeTab === 'transactions'" v-loading="loading" :data="rows" border>
        <el-table-column prop="txnId" label="流水 ID" min-width="190" class-name="life-id" />
        <el-table-column prop="userId" label="用户 ID" min-width="160" class-name="life-id" />
        <el-table-column label="类型" width="160"><template slot-scope="scope">{{ transactionTypeName(scope.row.txnType) }}</template></el-table-column>
        <el-table-column label="金额" width="115" align="right"><template slot-scope="scope"><span :class="transactionAmountClass(scope.row.txnType)">{{ transactionAmountSign(scope.row.txnType) }}¥{{ money(scope.row.amount) }}</span></template></el-table-column>
        <el-table-column label="可用余额" width="150" align="right"><template slot-scope="scope">¥{{ money(scope.row.availableBefore) }} → ¥{{ money(scope.row.availableAfter) }}</template></el-table-column>
        <el-table-column label="冻结余额" width="150" align="right"><template slot-scope="scope">¥{{ money(scope.row.frozenBefore) }} → ¥{{ money(scope.row.frozenAfter) }}</template></el-table-column>
        <el-table-column prop="businessType" label="业务类型" width="140" />
        <el-table-column prop="businessId" label="业务 ID" min-width="180" class-name="life-id" />
        <el-table-column prop="remark" label="说明" min-width="210" show-overflow-tooltip />
        <el-table-column prop="createTime" label="发生时间" width="170" />
      </el-table>

      <el-table v-else-if="activeTab === 'exceptions'" v-loading="loading" :data="rows" border>
        <el-table-column prop="exceptionId" label="异常 ID" min-width="190" class-name="life-id" />
        <el-table-column prop="exceptionType" label="异常类型" min-width="180" />
        <el-table-column prop="businessType" label="业务类型" width="150" />
        <el-table-column prop="businessId" label="业务 ID" min-width="190" class-name="life-id" />
        <el-table-column label="期望金额" width="115" align="right"><template slot-scope="scope">¥{{ money(scope.row.expectedAmount) }}</template></el-table-column>
        <el-table-column label="实际金额" width="115" align="right"><template slot-scope="scope">¥{{ money(scope.row.actualAmount) }}</template></el-table-column>
        <el-table-column label="状态" width="100"><template slot-scope="scope"><el-tag :type="scope.row.status === 'OPEN' ? 'danger' : 'success'" size="small">{{ scope.row.status === 'OPEN' ? '待处理' : '已解决' }}</el-tag></template></el-table-column>
        <el-table-column prop="resolution" label="处置结果" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createTime" label="发生时间" width="170" />
      </el-table>

      <el-table v-else-if="settlementView === 'payables'" v-loading="loading" :data="rows" border>
        <el-table-column prop="payableId" label="应付 ID" min-width="190" class-name="life-id" />
        <el-table-column prop="propertyCompanyId" label="物业公司" min-width="180" class-name="life-id" />
        <el-table-column prop="communityId" label="小区 ID" min-width="160" class-name="life-id" />
        <el-table-column prop="deductionOrderId" label="抵扣支付单" min-width="190" class-name="life-id" />
        <el-table-column label="类型" width="140"><template slot-scope="scope">{{ payableTypeName(scope.row.payableType) }}</template></el-table-column>
        <el-table-column label="金额" width="120" align="right"><template slot-scope="scope"><span :class="['life-money', Number(scope.row.amount || 0) < 0 ? 'is-danger' : '']">¥{{ money(scope.row.amount) }}</span></template></el-table-column>
        <el-table-column prop="settlementMonth" label="月份" width="100" />
        <el-table-column label="状态" width="110"><template slot-scope="scope"><el-tag size="small" effect="plain">{{ payableStateName(scope.row.state) }}</el-tag></template></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" />
      </el-table>

      <el-table v-else v-loading="loading" :data="rows" border>
        <el-table-column prop="batchNo" label="批次号" min-width="190" class-name="life-id" />
        <el-table-column prop="propertyCompanyId" label="物业公司" min-width="180" class-name="life-id" />
        <el-table-column prop="settlementMonth" label="月份" width="95" />
        <el-table-column label="应付总额" width="130" align="right"><template slot-scope="scope"><span class="life-money">¥{{ money(scope.row.totalAmount) }}</span></template></el-table-column>
        <el-table-column label="状态" width="110"><template slot-scope="scope"><el-tag :type="settlementStateType(scope.row.state)" size="small">{{ settlementStateName(scope.row.state) }}</el-tag></template></el-table-column>
        <el-table-column label="付款凭证" min-width="160"><template slot-scope="scope"><span v-if="scope.row.paymentVoucherUrl" class="life-id">{{ scope.row.paymentVoucherUrl }}</span><span v-else>-</span></template></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="270" fixed="right"><template slot-scope="scope">
          <el-button type="text" icon="el-icon-document" @click="openLines(scope.row)">明细</el-button>
          <el-button v-if="isPlatform && scope.row.state === 'DRAFT'" type="text" icon="el-icon-position" @click="issueBatch(scope.row)">发出</el-button>
          <el-button v-if="isPlatform && scope.row.state === 'ISSUED'" type="text" icon="el-icon-upload2" @click="openPay(scope.row)">付款</el-button>
          <el-button v-if="!isPlatform && scope.row.state === 'PAID'" type="text" icon="el-icon-circle-check" @click="confirmBatch(scope.row)">确认</el-button>
          <el-button v-if="!isPlatform && (scope.row.state === 'ISSUED' || scope.row.state === 'PAID')" type="text" class="is-danger" icon="el-icon-warning-outline" @click="openDispute(scope.row)">异议</el-button>
        </template></el-table-column>
      </el-table>

      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size" :page-sizes="[10, 20, 50]" :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="changeSize" @current-change="load" />
    </section>

    <el-dialog title="生成物业月结批次" :visible.sync="generateVisible" width="520px" destroy-on-close>
      <el-form ref="generateForm" :model="generateForm" :rules="generateRules" label-width="110px">
        <el-form-item label="物业公司" prop="propertyCompanyId"><el-input v-model.trim="generateForm.propertyCompanyId" /></el-form-item>
        <el-form-item label="结算月份" prop="settlementMonth"><el-date-picker v-model="generateForm.settlementMonth" type="month" value-format="yyyy-MM" :picker-options="monthPickerOptions" style="width: 100%" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="generateVisible = false">取消</el-button><el-button type="primary" :loading="submitting" @click="submitGenerate">生成</el-button></span>
    </el-dialog>

    <el-dialog title="上传付款凭证并标记已付" :visible.sync="payVisible" width="520px" destroy-on-close>
      <el-form label-width="90px">
        <el-form-item label="批次号"><span class="life-id">{{ actionBatch && actionBatch.batchNo }}</span></el-form-item>
        <el-form-item label="付款金额"><span class="life-money">¥{{ money(actionBatch && actionBatch.totalAmount) }}</span></el-form-item>
        <el-form-item label="付款凭证">
          <el-upload action="" :auto-upload="false" :limit="1" :on-change="handleVoucherChange" :on-remove="clearVoucher" accept=".jpg,.jpeg,.png,.pdf">
            <el-button size="small" icon="el-icon-upload2">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">支持 JPG、PNG 或 PDF，不超过 10MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="payVisible = false">取消</el-button><el-button type="primary" :loading="submitting" :disabled="!voucherFile" @click="submitPay">上传并标记已付</el-button></span>
    </el-dialog>

    <el-dialog title="提出月结异议" :visible.sync="disputeVisible" width="520px" destroy-on-close>
      <el-form ref="disputeForm" :model="disputeForm" :rules="disputeRules" label-width="90px">
        <el-form-item label="异议说明" prop="content"><el-input v-model.trim="disputeForm.content" type="textarea" :rows="5" maxlength="1000" show-word-limit /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="disputeVisible = false">取消</el-button><el-button type="danger" :loading="submitting" @click="submitDispute">提交异议</el-button></span>
    </el-dialog>

    <el-dialog title="月结明细与操作记录" :visible.sync="linesVisible" width="92%" top="5vh">
      <el-table v-loading="linesLoading" :data="lines" border max-height="430">
        <el-table-column prop="payableId" label="应付 ID" min-width="180" class-name="life-id" />
        <el-table-column prop="deductionOrderId" label="抵扣支付单" min-width="190" class-name="life-id" />
        <el-table-column prop="communityId" label="小区 ID" min-width="150" class-name="life-id" />
        <el-table-column prop="userId" label="用户 ID" min-width="150" class-name="life-id" />
        <el-table-column label="类型" width="140"><template slot-scope="scope">{{ payableTypeName(scope.row.payableType) }}</template></el-table-column>
        <el-table-column label="应付金额" width="120" align="right"><template slot-scope="scope"><span class="life-money">¥{{ money(scope.row.amount) }}</span></template></el-table-column>
        <el-table-column label="物业费全额" width="120" align="right"><template slot-scope="scope">¥{{ money(scope.row.grossAmount) }}</template></el-table-column>
        <el-table-column label="现金" width="100" align="right"><template slot-scope="scope">¥{{ money(scope.row.cashAmount) }}</template></el-table-column>
        <el-table-column prop="completedAt" label="完成时间" width="170" />
      </el-table>
      <h3 class="deduction-subtitle">操作记录</h3>
      <el-table :data="actions" border max-height="220">
        <el-table-column prop="actionType" label="操作" width="110" />
        <el-table-column label="状态变化" width="180"><template slot-scope="scope">{{ scope.row.fromState || '-' }} → {{ scope.row.toState || '-' }}</template></el-table-column>
        <el-table-column prop="operatorRole" label="操作方" width="110" />
        <el-table-column prop="operatorId" label="操作人" min-width="160" class-name="life-id" />
        <el-table-column prop="content" label="说明" min-width="220" show-overflow-tooltip />
        <el-table-column prop="attachmentUrl" label="附件" min-width="160" class-name="life-id" />
        <el-table-column prop="createTime" label="时间" width="170" />
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="linePage.current" :page-size="linePage.size" :total="linePage.total" layout="total, prev, pager, next" @current-change="loadLines" />
    </el-dialog>
  </div>
</template>

<script>
import {
  confirmDeductionSettlementBatch,
  disputeDeductionSettlementBatch,
  generateDeductionSettlementBatch,
  issueDeductionSettlementBatch,
  listDeductionOperations,
  listDeductionSettlementBatches,
  listDeductionSettlementLines,
  payDeductionSettlementBatch
} from '@/api/life/deductionApi'
import { uploadFile } from '@/api/staff/addStaffApi'
import { getStoreInfo } from '@/api/user/indexApi'

const PLATFORM_STORE = '800900000001'

export default {
  name: 'DeductionOperationList',
  data() {
    return {
      activeTab: 'accounts',
      isPlatform: true,
      loading: false,
      submitting: false,
      rows: [],
      filters: {},
      page: { current: 1, size: 20, total: 0 },
      settlementView: 'batches',
      earningStatuses: [
        { value: 'PENDING', label: '待结算' }, { value: 'SETTLED', label: '已结算' },
        { value: 'PARTIAL_REVERSED', label: '部分冲正' }, { value: 'REVERSED', label: '已冲正' }, { value: 'VOID', label: '已作废' }
      ],
      creditLotStatuses: [
        { value: 'ACTIVE', label: '有效' }, { value: 'EXHAUSTED', label: '已用完' },
        { value: 'EXPIRED', label: '已过期' }, { value: 'REVERSED', label: '已冲正' }
      ],
      transactionTypes: [
        { value: 'SETTLE_CREDIT', label: '结算入账' }, { value: 'PAY_HOLD', label: '支付冻结' },
        { value: 'PAY_COMMIT', label: '支付核销' }, { value: 'PAY_RELEASE', label: '冻结释放' },
        { value: 'EXPIRE_DEBIT', label: '到期核销' }, { value: 'REVERSAL_DEBIT', label: '收益冲正' },
        { value: 'RECOVERY_OFFSET', label: '追偿抵扣' }, { value: 'FEE_REFUND_CREDIT', label: '退费返还' },
        { value: 'FEE_REFUND_EXPIRED', label: '退费已过期' },
        { value: 'FEE_REFUND_RECOVERY_OFFSET', label: '退费冲减追偿' }, { value: 'MIGRATION', label: '历史迁移' }
      ],
      settlementStateOptions: [
        { value: 'DRAFT', label: '草稿' }, { value: 'ISSUED', label: '已发出' },
        { value: 'PAID', label: '已付款' }, { value: 'CONFIRMED', label: '已确认' }
      ],
      generateVisible: false,
      generateForm: { propertyCompanyId: '', settlementMonth: '' },
      generateRules: {
        propertyCompanyId: [{ required: true, message: '请输入物业公司 ID', trigger: 'blur' }],
        settlementMonth: [{ required: true, message: '请选择结算月份', trigger: 'change' }]
      },
      monthPickerOptions: { disabledDate: time => time.getTime() >= new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() },
      payVisible: false,
      actionBatch: null,
      voucherFile: null,
      disputeVisible: false,
      disputeForm: { batchId: '', propertyCompanyId: '', content: '' },
      disputeRules: { content: [{ required: true, message: '请输入异议说明', trigger: 'blur' }] },
      linesVisible: false,
      linesLoading: false,
      lines: [],
      actions: [],
      linePage: { current: 1, size: 20, total: 0 }
    }
  },
  async created() {
    try {
      const store = await getStoreInfo()
      this.isPlatform = store.storeTypeCd === PLATFORM_STORE
      this.activeTab = this.isPlatform ? 'accounts' : 'settlement'
    } catch (error) {
      this.$message.error(error.message || '获取登录主体失败')
      return
    }
    this.resetFilters()
    this.load()
  },
  methods: {
    resetFilters() {
      if (this.activeTab === 'accounts' || this.activeTab === 'recoverables') this.filters = { userId: '' }
      else if (this.activeTab === 'earnings') this.filters = { userId: '', platformCode: '', earningStatus: '' }
      else if (this.activeTab === 'creditLots') this.filters = { userId: '', platformCode: '', lotStatus: '' }
      else if (this.activeTab === 'transactions') this.filters = { userId: '', txnType: '' }
      else if (this.activeTab === 'exceptions') this.filters = { status: 'OPEN', exceptionType: '' }
      else this.filters = { propertyCompanyId: '', settlementMonth: '', state: '' }
    },
    changeTab() { this.page.current = 1; this.resetFilters(); this.load() },
    search() { this.page.current = 1; this.load() },
    reset() { this.page.current = 1; this.resetFilters(); this.load() },
    changeSize(size) { this.page.size = size; this.page.current = 1; this.load() },
    openUserDetails(row, tab) {
      this.activeTab = tab
      this.page.current = 1
      this.resetFilters()
      this.filters.userId = row.userId
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const params = { ...this.filters, page: this.page.current, row: this.page.size }
        let res
        if (this.activeTab === 'settlement' && this.settlementView === 'batches') res = await listDeductionSettlementBatches(params)
        else res = await listDeductionOperations(this.activeTab === 'settlement' ? 'payables' : this.activeTab, params)
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.rows = []
        this.page.total = 0
        this.$message.error(error.message || '加载抵扣金数据失败')
      } finally { this.loading = false }
    },
    openGenerate() {
      this.generateForm = { propertyCompanyId: this.filters.propertyCompanyId || '', settlementMonth: this.filters.settlementMonth || '' }
      this.generateVisible = true
      this.$nextTick(() => this.$refs.generateForm && this.$refs.generateForm.clearValidate())
    },
    submitGenerate() {
      this.$refs.generateForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await generateDeductionSettlementBatch(this.generateForm)
          this.$message.success('月结批次已生成')
          this.generateVisible = false
          this.load()
        } catch (error) { this.$message.error(error.message || '生成失败') } finally { this.submitting = false }
      })
    },
    issueBatch(row) {
      this.$confirm('发出后将进入物业核对和付款流程，确认继续？', '发出月结', { type: 'warning' }).then(async () => {
        try { await issueDeductionSettlementBatch({ batchId: row.batchId }); this.$message.success('月结已发出'); this.load() } catch (error) { this.$message.error(error.message || '发出失败') }
      }).catch(() => {})
    },
    openPay(row) { this.actionBatch = row; this.voucherFile = null; this.payVisible = true },
    handleVoucherChange(file) {
      const raw = file.raw
      if (!raw) return
      if (raw.size > 10 * 1024 * 1024) { this.$message.error('付款凭证不能超过 10MB'); this.voucherFile = null; return }
      const allowed = /\.(jpe?g|png|pdf)$/i.test(raw.name || '')
      if (!allowed) { this.$message.error('仅支持 JPG、PNG 或 PDF 凭证'); this.voucherFile = null; return }
      this.voucherFile = raw
    },
    clearVoucher() { this.voucherFile = null },
    async submitPay() {
      if (!this.actionBatch || !this.voucherFile) return
      this.submitting = true
      try {
        const formData = new FormData()
        formData.append('uploadFile', this.voucherFile)
        formData.append('communityId', '-1')
        const uploaded = await uploadFile(formData)
        const fileId = uploaded.fileId || (uploaded.data && uploaded.data.fileId)
        if (!fileId) throw new Error('凭证上传未返回文件 ID')
        await payDeductionSettlementBatch({ batchId: this.actionBatch.batchId, paymentVoucherUrl: fileId })
        this.$message.success('付款凭证已保存，批次已标记付款')
        this.payVisible = false
        this.load()
      } catch (error) { this.$message.error(error.message || '付款登记失败') } finally { this.submitting = false }
    },
    confirmBatch(row) {
      this.$confirm('确认已收到该批次全部款项？', '确认收款', { type: 'warning' }).then(async () => {
        try { await confirmDeductionSettlementBatch({ batchId: row.batchId, propertyCompanyId: row.propertyCompanyId }); this.$message.success('收款已确认'); this.load() } catch (error) { this.$message.error(error.message || '确认失败') }
      }).catch(() => {})
    },
    openDispute(row) {
      this.disputeForm = { batchId: row.batchId, propertyCompanyId: row.propertyCompanyId, content: '' }
      this.disputeVisible = true
      this.$nextTick(() => this.$refs.disputeForm && this.$refs.disputeForm.clearValidate())
    },
    submitDispute() {
      this.$refs.disputeForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try { await disputeDeductionSettlementBatch(this.disputeForm); this.$message.success('异议已提交'); this.disputeVisible = false; this.load() } catch (error) { this.$message.error(error.message || '提交失败') } finally { this.submitting = false }
      })
    },
    openLines(row) { this.actionBatch = row; this.linePage.current = 1; this.linesVisible = true; this.loadLines() },
    async loadLines() {
      if (!this.actionBatch) return
      this.linesLoading = true
      try {
        const res = await listDeductionSettlementLines({ batchId: this.actionBatch.batchId, propertyCompanyId: this.actionBatch.propertyCompanyId, page: this.linePage.current, row: this.linePage.size })
        const data = res.data || {}
        this.lines = data.records || []
        this.actions = data.actions || []
        this.linePage.total = Number(data.total || 0)
      } catch (error) { this.$message.error(error.message || '加载月结明细失败') } finally { this.linesLoading = false }
    },
    money(value) { return Number(value || 0).toFixed(2) },
    earningStatusName(value) { return (this.earningStatuses.find(item => item.value === value) || { label: value || '未知' }).label },
    earningStatusType(value) { return { PENDING: 'warning', SETTLED: 'success', PARTIAL_REVERSED: 'warning', REVERSED: 'danger', VOID: 'info' }[value] || 'info' },
    creditLotStatusName(value) { return (this.creditLotStatuses.find(item => item.value === value) || { label: value || '未知' }).label },
    creditLotStatusType(value) { return { ACTIVE: 'success', EXHAUSTED: 'info', EXPIRED: 'danger', REVERSED: 'warning' }[value] || 'info' },
    transactionTypeName(value) { return (this.transactionTypes.find(item => item.value === value) || { label: value || '未知' }).label },
    transactionAmountSign(value) { return ['SETTLE_CREDIT', 'PAY_RELEASE', 'FEE_REFUND_CREDIT', 'MIGRATION'].includes(value) ? '+' : (['PAY_COMMIT', 'REVERSAL_DEBIT', 'EXPIRE_DEBIT'].includes(value) ? '-' : '') },
    transactionAmountClass(value) { return this.transactionAmountSign(value) === '+' ? 'is-positive' : (this.transactionAmountSign(value) === '-' ? 'is-danger' : '') },
    settlementStateName(value) { return (this.settlementStateOptions.find(item => item.value === value) || { label: value || '未知' }).label },
    settlementStateType(value) { return { DRAFT: 'info', ISSUED: 'warning', PAID: 'primary', CONFIRMED: 'success' }[value] || 'info' },
    payableTypeName(value) { return { PAYMENT: '抵扣应付', REFUND_ADJUSTMENT: '退费调减', MANUAL_ADJUSTMENT: '人工调整' }[value] || value },
    payableStateName(value) { return { UNSETTLED: '待入批次', IN_BATCH: '已入批次', SETTLED: '已结清' }[value] || value }
  }
}
</script>

<style lang="scss" scoped>
@import './life.scss';
.deduction-nav { padding-bottom: 0; }
.deduction-nav .life-panel__head { margin-bottom: 4px; }
.deduction-settlement-filter { align-items: center; }
.deduction-subtitle { margin: 18px 0 10px; font-size: 14px; letter-spacing: 0; }
.is-positive { color: #2f855a; }
.is-danger { color: #c53030; }
</style>
